import apiClient from './apiClient';

export const easybellApi = {
  getStatus: async () => (await apiClient.get('/easybell/status')).data,
  aktivieren: async () => (await apiClient.post('/easybell/aktivieren')).data,
  deaktivieren: async () => (await apiClient.post('/easybell/deaktivieren')).data,
  tokenErneuern: async () => (await apiClient.post('/easybell/token-erneuern')).data
};
